import axios from "axios";
import { API_URL } from "./ServiceAPI";

export const ReportAPI = {
  getReports: () => {
    return axios.get(`${API_URL}/Report/getReports`);
  },

  getWeeklyReports: () => {
    return axios.get(`${API_URL}/Report/getWeeklyReports`);
  },

  getGapReports: () => {
    return axios.get(`${API_URL}/Report/getGapReports`);
  },

  getNalogReports: () => {
    return axios.get(`${API_URL}/Report/getNalogReports`);
  },

  getCombinedInventuraReports: () => {
    return axios.get(`${API_URL}/Report/getCombinedInventuraReports`);
  },

  getFondBeforeReports: () => {
    return axios.get(`${API_URL}/Report/getFondBeforeReports`);
  },

  getFondAfterReports: () => {
    return axios.get(`${API_URL}/Report/getFondAfterReports`);
  },

  getFondTotalReports: () => {
    return axios.get(`${API_URL}/Report/getFondTotalReports`);
  },

  getHlsVideo: (id) => {
    return axios.get(`${API_URL}/Report/getVideo/${id}`);
  },

  getPreviewFileUrl: (id) => {
    return axios.get(`${API_URL}/Report/getPreviewFileUrl/${id}`);
  },

  getReportFile: (fileId, fileType) => {
    const suffix =
      typeof fileType !== "undefined" && fileType !== null
        ? `/${fileType}`
        : "";

    return axios({
      url: `${API_URL}/Report/getReportFile/${fileId}${suffix}`,
      method: "GET",
      responseType: "blob",
    });
  },

  getVideoDownloadLink: (fileId, setVideoReportProgress) => {
    return axios.get(`${API_URL}/Report/getVideoDownloadLink/${fileId}`, {
      responseType: "blob",
      onDownloadProgress: (event) => {
        if (setVideoReportProgress && event.total) {
          const percentCompleted = Math.round(
            (event.loaded * 100) / event.total
          );
          setVideoReportProgress(percentCompleted);
        }
      },
    });
  },

  downloadAllReports: () => {
    return axios.get(`${API_URL}/Report/downloadAll`, { responseType: "blob" });
  },

  printAllReports: () => {
    return axios.get(`${API_URL}/Report/printAll`, { responseType: "blob" });
  },
};